import { recordRumError } from '@/rum';

import type { ReactNode } from 'react';

import { Alert, Box, Button, Typography } from '@mui/material';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

const AppErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => (
  <Box sx={{ p: 4, maxWidth: 640, mx: 'auto' }}>
    <Alert severity="error" sx={{ mb: 2 }}>
      <Typography variant="h6" component="div" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {(error as Error).message}
      </Typography>
    </Alert>
    <Button variant="contained" onClick={resetErrorBoundary}>
      Try again
    </Button>
  </Box>
);

interface AppErrorBoundaryProps {
  children: ReactNode;
}

export const AppErrorBoundary = ({ children }: AppErrorBoundaryProps) => (
  <ErrorBoundary
    FallbackComponent={AppErrorFallback}
    onError={(error) => {
      recordRumError(error as Error);
    }}
  >
    {children}
  </ErrorBoundary>
);
